// CommentsHeader.tsx — "Comments (N)" heading + sort menu.
import styled from 'styled-components';
import { media } from '@/theme/media';
import { SortMenu } from './SortMenu';
import type { SortId } from './useCommentThread';

export interface CommentsHeaderProps {
  count: number;
  sort: SortId;
  onSort: (s: SortId) => void;
}

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;

  /* Wrap heading and sort menu on mobile so neither overflows */
  ${media.mobile`flex-wrap: wrap;`}
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.lg};
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Count = styled.span`
  color: ${({ theme }) => theme.color.textMuted};
  font-weight: 400;
`;

export function CommentsHeader({ count, sort, onSort }: CommentsHeaderProps) {
  return (
    <Row>
      <Heading>
        Comments <Count>({count})</Count>
      </Heading>
      <SortMenu sort={sort} onChange={onSort} />
    </Row>
  );
}
